import React, { createContext, useState, useContext } from 'react';
import PropTypes from 'prop-types';

const SubModuleContext = createContext();

export const Provider = ({ closed, disableAccordian, children }) => {
  const [open, setOpen] = useState(!closed);
  const toggleIsOpen = () => setOpen(!open);

  return (
    <SubModuleContext.Provider
      value={{
        isOpen: open,
        toggleIsOpen,
        disableAccordian,
      }}
    >
      {children}
    </SubModuleContext.Provider>
  );
};

Provider.propTypes = {
  children: PropTypes.node.isRequired,
  closed: PropTypes.bool,
  disableAccordian: PropTypes.bool,
};

Provider.defaultProps = {
  closed: false,
  disableAccordian: false,
};

export const useSubModuleContext = () => useContext(SubModuleContext);
